import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Form, Input, Button, Typography, Alert, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuthStore } from '../../store/auth.store';

const { Title, Text } = Typography;

export default function LoginPage() {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { login, isLoading, error } = useAuthStore();
    const [loginError, setLoginError] = useState<string | null>(null);

    const handleSubmit = async (values: { email: string; password: string }) => {
        setLoginError(null);
        try {
            await login(values.email, values.password);
            // Play welcome sound
            try {
                const audio = new Audio('/welcome.mp3');
                audio.play().catch(() => { });
            } catch (_e) { }
            navigate('/dashboard');
        } catch (err: any) {
            setLoginError(err.response?.data?.message || 'Błąd logowania');
        }
    };

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            }}
        >
            <Card
                style={{
                    width: 400,
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                }}
            >
                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    <div style={{ textAlign: 'center' }}>
                        <Title level={2} style={{ margin: 0, color: '#1890ff' }}>
                            CureCraft ERP
                        </Title>
                        <Text type="secondary">System zarządzania firmą</Text>
                    </div>

                    {loginError && (
                        <Alert
                            message={loginError}
                            type="error"
                            showIcon
                            closable
                            onClose={() => setLoginError(null)}
                        />
                    )}

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                        autoComplete="off"
                    >
                        <Form.Item
                            name="email"
                            label="Email"
                            rules={[
                                { required: true, message: 'Podaj email' },
                                { type: 'email', message: 'Nieprawidłowy format email' },
                            ]}
                        >
                            <Input
                                prefix={<UserOutlined />}
                                placeholder="admin@curecraft.pl"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            label="Hasło"
                            rules={[{ required: true, message: 'Podaj hasło' }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="Hasło"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                size="large"
                                block
                                loading={isLoading}
                            >
                                Zaloguj się
                            </Button>
                        </Form.Item>
                    </Form>


                </Space>
            </Card>
        </div>
    );
}
